'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IoRibbonA = function IoRibbonA(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm27.3 2.5l6.2 7.5-5 10.5c-1.9-2.4-4.6-3.9-7.7-4.2z m-15 0l6.4 13.8c-3.1 0.3-5.8 1.8-7.7 4.2l-5-10.5z m8.5 0h5.2l-4.1 8.8h-4.3l-4.1-8.8h7.3z m-1 15c5.5 0 10 4.5 10 10s-4.5 10-10 10-10-4.5-10-10 4.4-10 10-10z m0 17.5c4.1 0 7.5-3.4 7.5-7.5s-3.4-7.5-7.5-7.5-7.5 3.4-7.5 7.5 3.3 7.5 7.5 7.5z m0-14.4c3.8 0 6.8 3.1 6.8 6.9s-3 6.9-6.8 6.9-6.9-3.1-6.9-6.9 3-6.9 6.9-6.9z' })
        )
    );
};

exports.default = IoRibbonA;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/io/ribbon-a.js
// module id = 2884
// module chunks = 168707334958949